import 'modaal';
import $ from 'jquery';

export default class ModaalTransformer {
  constructor(element, settings) {
    this.old = element;
    this.settings = settings;
    this.type = 'image';

    // Add custom video type.
    if (this.settings.isVideo) {
      this.type = 'video';
    }

    // Remove unneeded attributes and classes.
    this.old.removeAttribute('rel');
    this.old.classList.remove('lightbox-processed');

    // Clone the element to insure removal of previously set lightbox listeners functions.
    this.new = this.old.cloneNode(true);
    this.old.parentNode.replaceChild(this.new, this.old);

    // Add Modaal attributes for this particular link type.
    this.new.setAttribute('data-modaal-type', this.type);

    // If this is an image gallery, add the group data attribute.
    if (this.settings.isGallery) {
      this.new.setAttribute('data-group', 'gallery');
    }

    // Add the caption, if applicable.
    const image = this.new.querySelector('img');
    const caption = image.getAttribute('title');
    if (caption.length) {
      this.new.setAttribute('data-modaal-desc', caption);
    }

    // Add a replacement listener for our new link.
    this.new.addEventListener('click', this.clickHandler.bind(this));
  }

  clickHandler(event) {
    event.preventDefault();
    $(this.new).modaal({
      type: this.type,
      start_open: true,
      animation: 'none',
      outer_controls: true,
    });
  }
}
